module.exports = "/assets/images/google_d15c57.svg";